import { backendLoginUrl, backendLogoutUrl } from './authUrls';
import { baseUrl } from './baseUrl';
import { cdn } from './cdn';
import { DEFAULT_APP_BASE_URL, DEFAULT_ENV, DEFAULT_PUBLIC_URL } from './constants';
import { ENV } from './env';
import { getMerchantName } from './merchantName';
import {
  advanceSettings,
  homePage,
  automation,
  paymentMethods,
  publicLogin,
  recognition,
  salesforce,
  teams,
  underMaintenance
} from './settings';

//! VARIABLES
const publicUrl = process.env.PUBLIC_URL || DEFAULT_PUBLIC_URL;
const env = process.env.REACT_APP_ENV || DEFAULT_ENV.production;
const appBaseUrl = process.env.REACT_APP_BASE_URL || DEFAULT_APP_BASE_URL;
const isDevelopment = env === DEFAULT_ENV.development;
const isProduction = env === DEFAULT_ENV.production;
const isLocal = env === DEFAULT_ENV.local;
const isTest = env === DEFAULT_ENV.test;
const isClient = typeof window !== 'undefined';

const merchantName = getMerchantName();

export const configs = {
  automation,
  homePage,
  baseUrl,
  teams,
  salesforce,
  publicLogin,
  advanceSettings,
  recognition,
  underMaintenance,
  paymentMethods,
  publicUrl,
  env,
  appBaseUrl,
  cdn,
  isDevelopment,
  isProduction,
  isLocal,
  isTest,
  isClient,
  merchantName,
  backendLoginUrl,
  backendLogoutUrl,
  tracker: {
    clickstream: {
      enabled: !!ENV.CLICKSTREAM_API_BASE_URL
    },
    gtm: {
      enabled: !!ENV.GTM_ID
    }
  }
};

export const constants = {
  general: {
    giftMessageLimit: 180,
    giftMessageMaxLineCount: 12
  },
  products: {
    filter: {}
  }
};
